import initTinyMCEShortcodesPlugin from './tinymce/shortcodes.js';
window.initTinyMCEShortcodesPlugin = initTinyMCEShortcodesPlugin;

import initTinyMCEFilebrowserPlugin from './tinymce/filebrowser.js';
window.initTinyMCEFilebrowserPlugin = initTinyMCEFilebrowserPlugin;

import initTinyMCEContentlinkPlugin from './tinymce/contentlinks.js';
window.initTinyMCEContentlinkPlugin = initTinyMCEContentlinkPlugin;

import initTinyMCEImageBrowser from './tinymce/imagebrowser.js';
window.initTinyMCEImageBrowser = initTinyMCEImageBrowser;
